import it from 'date-fns/locale/it';
import { set, add, startOfMonth, endOfMonth, setHours, setMinutes, addHours, addMinutes, isAfter, isBefore, startOfDay, startOfWeek, parse, getDay, format, parseISO, previousSunday, getHours, getMinutes } from 'date-fns'
import React, { ChangeEvent, useCallback, useEffect, useMemo, useState, useContext } from 'react';
import { Calendar, Event, dateFnsLocalizer, Views, View } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Accordion, Alert, Breadcrumb, Button, Card, Col, Container, Form, ListGroup, Modal, Row, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import AppLoader from '../../components/AppLoader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { KeyValue, Protocol, Schedule, Therapy } from '../../models/Protocol';
import { Protocols } from '../../api/Protocols';
import { useFullScreenLoader } from '../../contexts/fullScreenLoader';
import { useToasts } from '../../contexts/toasts';
import { ScheduledTherapies } from '../../models/ScheduledTherapies';
import { Patients } from '../../api/Patients';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import IconButton from '../../components/IconButton';
import { Devices } from '../../api/Devices';
import { Tasks } from '../../api/Tasks';
import { Therapies } from '../../api/Therapies';
import { Device } from '../../models/Device';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { Task } from '../../models/Task';
import { TaskParameter, pType } from '../../models/TaskParameter';
import { update } from 'lodash';
import './SchedulerPage.scss';
import { setDay } from 'date-fns/esm';
import { User } from '../../models/User';
import { Users } from '../../api/Users';


const locales = { 'it': it }
const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales,
})




export default function SchedulerPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams();

    const [myEvents, setEvents] = useState<any[]>([]);
    const [view, setView] = useState<View>(Views.MONTH)
    const [date, setDate] = useState<Date>(new Date())
    const [protocols, setProtocols] = useState<Protocol[] | null>();
    const [schedule, setSchedule] = useState<ScheduledTherapies | null>();

    const [patientDetail, setPatientDetail] = useState<User | null>();

    const [newEvent, setNewEvent] = useState<Event>({});

    const [devicesList, setDeviceList] = useState<Device[]>();

    const [selectedProtocol, setSelectedProtocol] = useState<Protocol | null>();

    const [validated, setValidated] = useState<boolean>(false);
    const [showSelecProtocolModal, setSelectProtocolModal] = useState<boolean>(false);

    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [protocolToDelete, setProtocolToDelete] = useState<Protocol | null>();

    const [showRemoveScheduledModal, setShowRemoveScheduledModal] = useState<boolean>(false);
    const [scheduleToRemove, setScheduleToRemove] = useState<any | undefined>();

    const [showSessionDetailModal, setShowSessionDetailModal] = useState<boolean>(false);
    const [sessionDetail, setSessionDetail] = useState<Event>()

    const [showCustomizeTaskModal, setShowCustomizeTaskModal] = useState<boolean>(false);
    const [taskDetail, setTaskDetail] = useState<Task>()
    const [customParams, setCustomParams] = useState<Task[]>([]);

    const [showAddSessionModal, setAddSessionModal] = useState<boolean>(false);

    const [filterDevice, setFilterDevice] = useState<number>(0)

    const [activeSession, setActiveSession] = useState<string | undefined>();
    const [activeProtocol, setActiveProtocol] = useState<string | undefined>();

    const { showLoader, hideLoader } = useFullScreenLoader();
    const { showToast } = useToasts();

    useEffect(() => {
        initProtocols();
        initDeviceList()
        initPatientDetail();
        // eslint-disable-next-line
    }, []);

    const reset = () => {
        setProtocols(null);
        setSelectedProtocol(null);
        setProtocolToDelete(null);
        initDeviceList();
        initProtocols();
        setNewEvent({});
        setCustomParams([]);
    }

    const logs = (elem: any) => {
        console.log(elem)
        console.log("Events: ", myEvents);
        console.log("Protocols: ", protocols);
        console.log("Calendar: ", schedule);
        console.log("Selected Protocol: ", selectedProtocol);
        console.log("NewEvent", newEvent);
        console.log("CustomizedTasks", customParams)

    }
    const initPatientDetail = () => {
        Patients.getPatient(id!)
            .then(
                ({ data: patient }) => {
                    setPatientDetail(patient);
                },
                (err) => {
                    const message = err.response?.data?.message || err.message;
                    const status = err.response?.status;
                    showToast!('Patient-error', message, `Patient Error ${status ? `(${status})` : ''}`, 'danger');
                }
            );
    }

    const initProtocols = () => {
        showLoader!();
        Protocols.getTenantProtocols()
            .then(
                ({ data: protocols }) => {
                    protocols.map((p) => { p.checked = false; return p });
                    setProtocols(protocols)
                    initScheduledTherapies(protocols);
                    hideLoader!()
                },
                (err) => {
                    const message = err.response?.data?.message || err.message;
                    const status = err.response?.status;
                    hideLoader!();
                    showToast!('protocols-error', message, `Protocols Error ${status ? `(${status})` : ''}`, 'danger');
                }
            );
    }

    const initDeviceList = () => {

        Devices.getDevicesList()
            .then(
                ({ data: devices }) => {

                    setDeviceList(devices)
                    hideLoader!()
                },
                (err) => {
                    const message = err.response?.data?.message || err.message;
                    const status = err.response?.status;
                    hideLoader!();
                    showToast!('devices-error', message, `Devices Error ${status ? `(${status})` : ''}`, 'danger');
                }
            );
    }

    function initScheduledTherapies(protocols: Protocol[], start?: Date, end?: Date) {
        showLoader!();
        Patients.getPatientSchedule(Number(id!), format(start ? start : startOfMonth(date), 'yyyy-MM-dd'), format(end ? end : endOfMonth(date), 'yyyy-MM-dd'), { params: { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone } }).then(
            ({ data: scheduledTherapies }: AxiosResponse<ScheduledTherapies>) => {
                console.log("SCHEDULED THERAPIES", scheduledTherapies)
                setSchedule(scheduledTherapies)
                let scheduledEvent = scheduledTherapies.schedule.map((schedule) => {

                    let date = parse(schedule.date, 'yyyy-MM-dd', new Date());

                    let mappedSchedule = schedule.therapies.map((therapy) => {

                        let [hours, minutes] = therapy.time.split(':');
                        let calendarDate = setHours(setMinutes(date, Number(minutes)), Number(hours));
                        let title = therapy.protocolName! + '-' + therapy.sessionName;

                        return {
                            allDay: false,
                            title: title,
                            start: calendarDate,
                            end: addMinutes(calendarDate, therapy.duration || 30),
                            resource: { ...therapy },
                        }
                    })


                    return mappedSchedule;

                })

                let updatedEvents = [];
                updatedEvents.push(...scheduledEvent.flat());
                setEvents(updatedEvents)

                hideLoader!()
            },
            (err) => {
                const message = err.response?.data?.message || err.message;
                const status = err.response?.status;
                hideLoader!();
                showToast!('patientSchedule-error', message, `Patient Schedule Error ${status ? `(${status})` : ''}`, 'danger');
            }
        );
    }

    function updateScheduledTherapies(protocols: Protocol[], start?: Date, end?: Date) {
        showLoader!();
        Patients.getPatientSchedule(Number(id!), format(start ? start : startOfMonth(date), 'yyyy-MM-dd'), format(end ? end : endOfMonth(date), 'yyyy-MM-dd'), { params: { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone } }).then(
            ({ data: scheduledTherapies }: AxiosResponse<ScheduledTherapies>) => {
                let updatedProtocols = [...schedule!.protocols]
                scheduledTherapies.protocols.forEach((p) => {
                    if (!updatedProtocols.filter(up => up.id === p.id).length) {
                        updatedProtocols.push(p)
                    }
                })
                let updatedTherapies = [...schedule!.schedule]
                scheduledTherapies.schedule.forEach((s) => {
                    if (!updatedTherapies.filter(ut => ut.date === s.date).length) {
                        updatedTherapies.push(s)
                    }
                })

                let updatedSchedule = { protocols: updatedProtocols, schedule: updatedTherapies }
                setSchedule(updatedSchedule)



                let scheduledEvent = updatedSchedule.schedule.map((schedule) => {

                    let date = parse(schedule.date, 'yyyy-MM-dd', new Date());

                    let mappedSchedule = schedule.therapies.map((therapy) => {

                        let [hours, minutes] = therapy.time.split(':');
                        let calendarDate = setHours(setMinutes(date, Number(minutes)), Number(hours));

                        let title = protocols?.find(p => p.id === therapy.protocolId)?.name + '-' + therapy.sessionName;

                        return {
                            allDay: false,
                            title: title,
                            start: calendarDate,
                            end: addMinutes(calendarDate, therapy.duration || 30),
                            resource: { ...therapy },
                        }
                    })


                    return mappedSchedule;

                }).flat()

                if (newEvent?.resource?.therapyId) {
                    scheduledEvent = scheduledEvent.filter(sE => sE.resource.therapyId !== newEvent?.resource?.therapyId)
                }

                let updatedEvents = [...myEvents.filter(evt => evt.resource.new)];
                updatedEvents.push(...scheduledEvent);
                setEvents(updatedEvents)

                hideLoader!()
            },
            (err) => {
                const message = err.response?.data?.message || err.message;
                const status = err.response?.status;
                hideLoader!();
                showToast!('patientSchedule-error', message, `Patient Schedule Error ${status ? `(${status})` : ''}`, 'danger');
            }
        );
    }

    const handleSelectedProtocolChange = (evt: React.ChangeEvent<HTMLSelectElement>) => {
        const value = evt.target.value;
        const relativeProtocol = protocols?.filter((p) => p.id === Number(value)).map(rP => ({ ...rP, therapies: rP.sessions }))!
        setSelectedProtocol(relativeProtocol[0]!);
    }
    const handleDeviceFilterChange = (evt: React.ChangeEvent<HTMLSelectElement>) => {
        const value = evt.target.value;
        setFilterDevice(Number(value))
    }

    const handleTherapyDeviceChange = (evt: React.ChangeEvent<HTMLSelectElement>) => {
        const value = evt.target.value;
        setNewEvent({ ...newEvent, resource: { ...newEvent.resource, deviceId: Number(value) } });
    }

    const handleActiveSessionChange = (
        eventKey: string | string[] | null | undefined,
        evt: Object
    ) => {
        setActiveSession(
            Array.isArray(eventKey) ? eventKey[0] : (eventKey as string)
        );
    };

    const handleActiveProtocolChange = (
        eventKey: string | string[] | null | undefined,
        evt: Object
    ) => {
        setActiveProtocol(
            Array.isArray(eventKey) ? eventKey[0] : (eventKey as string)
        );
    };

    function ContextAwareToggle({ children, eventKey, callback }: any) {
        const { activeEventKey } = useContext(AccordionContext);

        const decoratedOnClick = useAccordionButton(
            eventKey,
            () => callback && callback(eventKey),
        );

        const isCurrentEventKey = activeEventKey === eventKey;

        return (
            <IconButton className="ms-2" onClick={decoratedOnClick}>
                {isCurrentEventKey ? <FontAwesomeIcon icon={solid('chevron-up')} /> : <FontAwesomeIcon icon={solid('chevron-down')} />}
            </IconButton>
        );
    }

    const selectSessionToAdd = (sessionId: number) => {

        setNewEvent({ ...newEvent, resource: { ...newEvent.resource, sessionId: sessionId, tasks: [] } });
    }

    const removeScheduledSession = (sessionId: number) => {

        let updatedEvent = myEvents.filter(evt => evt.resource.sessionId !== sessionId || !evt.resource.new);

        setEvents(updatedEvent);

        let updateSelectedProtocol = selectedProtocol!;
        updateSelectedProtocol.sessions = selectedProtocol?.sessions.map((ses) => {
            if (ses.sessionId === sessionId) {
                return { ...ses, scheduled: undefined }
            } else {
                return ses
            }

        })!;

        setSelectedProtocol(updateSelectedProtocol);

    }

    const openTherapyRemoveModal = (therapy: any) => {
        setScheduleToRemove(therapy);
        setShowRemoveScheduledModal(true);
    }

    const removeScheduledTherapy = () => {
        showLoader!();
        Therapies.removeTherapySchedule(scheduleToRemove.therapyId)
            .then(
                (res) => {
                    setShowRemoveScheduledModal(false);
                    hideLoader!()
                    reset()
                },
                (err) => {
                    setShowRemoveScheduledModal(false);
                    const message = err.response?.data?.message || err.message;
                    const status = err.response?.status;
                    hideLoader!();
                    showToast!('therapy-error', message, `Therapies Error ${status ? `(${status})` : ''}`, 'danger');
                }
            );
    }

    const reScheduleSession = (sessionId: number) => {
        let updatedEvent = myEvents.filter(evt => evt.resource.sessionId !== sessionId || !evt.resource.new);
        setEvents(updatedEvent);

        let updateSelectedProtocol = selectedProtocol!;
        updateSelectedProtocol.sessions = selectedProtocol?.sessions.map((ses) => {
            if (ses.sessionId === sessionId) {
                return { ...ses, scheduled: undefined }
            } else {
                return ses
            }

        })!;

        setSelectedProtocol(updateSelectedProtocol);

        setNewEvent({ ...newEvent, resource: { ...newEvent.resource, sessionId: sessionId } });
    }

    const reScheduleExistingSession = (therapyId: any) => {

        let oldEvent = myEvents.find(evt => evt.resource.therapyId === therapyId)

        if (oldEvent === undefined) {
            oldEvent = recreateEvent(therapyId)
        }

        let updatedEvent = myEvents.filter(evt => evt.resource.therapyId !== therapyId);
        setEvents(updatedEvent);

        let updateSelectedProtocol = selectedProtocol!;
        updateSelectedProtocol.therapies = selectedProtocol?.therapies?.map((ses) => {
            if (ses.id === therapyId) {
                return { ...ses, scheduledDate: undefined }
            } else {
                return ses
            }

        })!;

        /*         console.log("NEW", newEvent)
                console.log("OLD", oldEvent) */

        setSelectedProtocol(updateSelectedProtocol);

        setNewEvent({ ...newEvent, title: oldEvent.title, resource: { ...oldEvent.resource } });

    }

    function recreateEvent(therapyId: number) {

        let protocolSession = selectedProtocol?.therapies?.filter(s => s.id === therapyId);
        let restoredTherapy = protocolSession?.map(pS =>
        ({
            ...pS,
            therapyId: pS.id,
            id: selectedProtocol?.id,
            protocolId: selectedProtocol?.protocolId,
            duration: pS.hours,
            time: getHours(parseISO(pS.scheduledDate!)).toString().padStart(2, '0') + ":" + getMinutes(parseISO(pS.scheduledDate!)).toString().padStart(2, '0'),
            tasks: []
        }))[0]

        let calendarDate = parseISO(restoredTherapy?.scheduledDate!);
        console.log("SELECTED PROTOCOL NAME", selectedProtocol?.name)
        console.log("RESTORED THERAPY NAME", restoredTherapy)
        let title = selectedProtocol?.name + '-' + restoredTherapy;

        return {
            allDay: false,
            title: title,
            start: calendarDate,
            end: addMinutes(calendarDate, restoredTherapy!.duration! || restoredTherapy!.hours! || 30),
            resource: { ...restoredTherapy }
        }

    }


    const customizeTask = (taskId: number, sessId: number) => {
        showLoader!()
        if (customParams.filter(t => t.id === taskId && t.sessionId === sessId).length) {
            setTaskDetail(customParams.filter(t => t.id === taskId && t.sessionId === sessId)[0]);
        } else {
            Tasks.getTenantTask(String(taskId)).then(({ data: task }) => {
                task.sessionId = sessId;
                setTaskDetail(task);
            }, (err) => {
                const message = err.response?.data?.message || err.message;
                const status = err.response?.status;
                showToast!('task-error', message, `Task Detail Error ${status ? `(${status})` : ''}`, 'danger');
            })
        }
        setShowCustomizeTaskModal(true);
        hideLoader!()
    }

    const customizeTaskIstance = (taskIstanceId: number, sessId: number) => {

        showLoader!()
        if (customParams.filter(t => t.id === taskIstanceId && t.sessionId === sessId).length) {
            setTaskDetail(customParams.filter(t => t.id === taskIstanceId && t.sessionId === sessId)[0]);
        } else {
            Tasks.getTenantTaskInstance(taskIstanceId).then(({ data: task }) => {
                task.sessionId = sessId;
                setTaskDetail(task);
            }, (err) => {
                const message = err.response?.data?.message || err.message;
                const status = err.response?.status;
                showToast!('task-error', message, `Task Detail Error ${status ? `(${status})` : ''}`, 'danger');
            })
        }
        setShowCustomizeTaskModal(true);
        hideLoader!()

    }

    const onNavigate = useCallback((newDate: Date) => {

        setDate(newDate)


    }, [setDate])


    const handleSelectSlot = (evt: Event) => {
        if (selectedProtocol?.therapies!.filter(s => s.scheduled === undefined).length && !isBefore(evt.start!, startOfDay(new Date()))) {
            let evtN = { ...evt, resource: { ...newEvent.resource, sessionId: newEvent.resource.sessionId } }
            setNewEvent(evtN);
            openAddSessionModal();
        }


    }


    const eventPropGetter =
        (event: Event, start: any, end: any, isSelected: boolean) => {

            return {
                ...(event.resource.patientId !== Number(id) && {
                    style: {
                        backgroundColor: '#bbb',
                    },
                }),

                ...(event.resource.new && {
                    style: {
                        backgroundColor: '#F8891A',
                    },
                }),

                ...(selectedProtocol?.therapies!.map(x => x.id).includes(event.resource.therapyId) && {
                    style: {
                        backgroundColor: '#F8891A',
                    },
                }),

                ...((event.resource.protocolInstanceId === selectedProtocol?.id) && !event.resource.new && {
                    style: {
                        backgroundColor: '#ee5252'
                    }
                }),
                ...(event.resource.isCompleted && event.resource.patientId === Number(id) && {

                    style: {
                        backgroundColor: '#71C562',
                    },
                }),
            }
        }


    const dayPropGetter = useCallback(
        (date: Date) => ({
            ...(isBefore(date, new Date()) && {
                className: 'rbc-off-range-bg'
            }),
        }),
        []
    )


    const handleSelectEvent = useCallback(
        (event: any) => {
            openSessionDetailModal(event);
        },
        []
    )

    const handleGoTo = (evt: React.ChangeEvent<HTMLInputElement>) => {
        let destination = setDay(parse(evt.target.value, 'yyyy-MM', new Date()), 15)
        setDate(destination)
        handleRangeChange({ start: destination, end: destination })

    }

    const handleRangeChange = (evt: any) => {

        if (Array.isArray(evt)) {
            return
        }

        let monthVisualized = previousSunday(evt.end)

        if (selectedProtocol) {
            updateScheduledTherapies(protocols!, startOfMonth(monthVisualized), endOfMonth(monthVisualized))
        }
        else {
            initScheduledTherapies(protocols!, startOfMonth(monthVisualized), endOfMonth(monthVisualized));
        }

    };


    const onView = (newView: View) => { setView(newView) }

    const openSelectProtocolModal = () => setSelectProtocolModal(true);
    const handleSelectProtocolModalClose = () => {
        setSelectProtocolModal(false);
        setSelectedProtocol(undefined);
    }

    const openDeleteModal = (protocolIstanceId: number) => {
        setProtocolToDelete(schedule!.protocols!.find(p => p.id === protocolIstanceId)! as Protocol)
        setShowDeleteModal(true);
    }
    const handleDeleteModalClose = () => setShowDeleteModal(false);

    const handleRemoveScheduleModal = () => setShowRemoveScheduledModal(false);

    const openAddSessionModal = () => setAddSessionModal(true);
    const handleAddSessionModalClose = () => {
        setAddSessionModal(false);
        setNewEvent({});
    }

    const openSessionDetailModal = (evt: Event) => {
        setSessionDetail(evt);
        setShowSessionDetailModal(true)
    };

    const handleSessionDetailModalClose = () => {
        setShowSessionDetailModal(false);
        setSessionDetail(undefined)
    }


    const handleCustomizeTaskModalClose = () => {
        setShowCustomizeTaskModal(false);
        setTaskDetail(undefined);
    }

    const modifyProtocolIstance = (protocolIstanceId: number) => {

        setSelectedProtocol(schedule!.protocols!.find(p => p.id === protocolIstanceId)! as Protocol);

    }

    const handleAddSession = (evt: React.FormEvent<HTMLFormElement>) => {
        const form = evt.currentTarget;
        evt.stopPropagation();
        evt.preventDefault();
        setValidated(true);

        if (form.checkValidity() === true) {
            let properEvent = newEvent;
            let [hours, minutes] = newEvent.resource.scheduledDate.split(':');

            let scheduledDate = set(newEvent.start!, { hours: Number(hours), minutes: Number(minutes) })


            properEvent.resource.scheduledDate = scheduledDate.toISOString();

            properEvent.start = scheduledDate;
            properEvent.end = add(scheduledDate, { minutes: properEvent.resource.duration });
            properEvent.title = selectedProtocol?.therapies!.find((s) => s.sessionId === properEvent.resource.sessionId)?.label || properEvent.resource.sessionName || properEvent.resource.name;
            properEvent.resource.new = true;


            setEvents((prev: Event[]) => [...prev, properEvent])

            let selectProtocolUpdate = selectedProtocol!

            selectProtocolUpdate.therapies![selectProtocolUpdate!.therapies!.findIndex(s => s.sessionId === properEvent.resource.sessionId)].scheduledDate = scheduledDate.toISOString();
            setSelectedProtocol(selectProtocolUpdate)


            handleAddSessionModalClose()
        }

    }

    const saveSchedule = () => {
        let patientSchedule: Schedule = {
            protocolId: selectedProtocol?.id!,
            pathologyId: selectedProtocol?.pathology!,
            therapies: myEvents.filter(evt => evt.resource.new).map(x => { return x.resource })
        }

        if (patientSchedule.therapies.length <= 0) {
            showToast!('patientSchedule-error', "At least one sessions must be scheduled before creating the instance", `Protocol Schedule ErrorS`, 'danger');
            return
        }
        if (customParams.length) {
            patientSchedule.therapies = patientSchedule.therapies.map(therapy => {
                return {
                    ...therapy, tasks: customParams.filter(task => task.sessionId === therapy.sessionId).map(task => {
                        return {
                            taskId: task.id,
                            parameters: task.parameters.map(p => {
                                if (p.type === pType.GENERATEDQUESTIONS) {
                                    return {
                                        'key': p.key,
                                        'value': p.value.map((q: any) => ({
                                            ...q,
                                            correct: Array.isArray(q.correct) ? q.correct : q.correct.split(',').map((t: string) => t.trim()),
                                            answers: Array.isArray(q.answers) ? q.answers : q.answers.split(',').map((t: string) => t.trim())
                                        })
                                        )
                                    }
                                }

                                if (p.type === pType.LISTINTEGER || p.type === pType.LISTFLOAT) {
                                    console.log(p.value)
                                    return {
                                        'key': p.key,
                                        'value': Array.isArray(p.value) ? p.value : p.value.split(',').map((t: string) => Number(t))
                                    }
                                }
                                if (p.type === pType.LISTTEXT) {
                                    return {
                                        'key': p.key,
                                        'value': Array.isArray(p.value) ? p.value : p.value.split(',').map((t: string) => t.trim())
                                    }
                                }

                                return { 'key': p.key, 'value': p.value }
                            }
                            )
                        }
                    }
                    )
                }
            })
        }

        showLoader!()
        Patients.savePatientSchedule(Number(id!), patientSchedule).then(
            (res) => {
                reset();
                hideLoader!()
            },
            (err) => {
                const message = err.response?.data?.message || err.message;
                const status = err.response?.status;
                hideLoader!();
                showToast!('patientSchedule-error', message, `Patient Schedule Error ${status ? `(${status})` : ''}`, 'danger');
            }
        )

    };


    const updateSchedule = () => {

        let patientSchedule: any = {
            name: selectedProtocol?.name,
            minDuration: selectedProtocol?.minDuration,
            sugDuration: selectedProtocol?.sugDuration,
            therapies: myEvents.filter(evt => evt.resource.new).map(x => { return { ...x.resource, id: x.resource.therapyId } })
        }

        if (customParams.length) {
            if (patientSchedule.therapies.length) {
                patientSchedule.therapies = patientSchedule.therapies.map((therapy: any) => {
                    return {
                        ...therapy, tasks: customParams.filter(task => task.sessionId === therapy.sessionId).map(task => {
                            return {
                                taskId: task.taskId,
                                parameters: task.parameters.map(p => { return { 'key': p.key, 'value': p.value } }
                                )
                            }
                        }
                        )
                    }
                })
            } else {
                let sessionIds: number[] = [];
                customParams.forEach((cp) => !sessionIds.includes(cp.sessionId!) ? sessionIds.push(cp.sessionId!) : '')

                let therapiesUpdated = selectedProtocol!.therapies!.filter((s) => sessionIds.includes(s.sessionId));

                therapiesUpdated = therapiesUpdated.map((therapy: any) => {
                    return {
                        ...therapy, tasks: customParams.filter(task => task.sessionId === therapy.sessionId).map(task => {
                            return {
                                taskId: task.taskId,
                                parameters: task.parameters.map(p => {
                                    if (p.type === pType.GENERATEDQUESTIONS) {
                                        return {
                                            'key': p.key,
                                            'value': p.value.map((q: any) => ({
                                                ...q,
                                                correct: Array.isArray(q.correct) ? q.correct : q.correct.split(',').map((t: string) => t.trim()),
                                                answers: Array.isArray(q.answers) ? q.answers : q.answers.split(',').map((t: string) => t.trim())
                                            })
                                            )
                                        }
                                    }

                                    if (p.type === pType.LISTINTEGER || p.type === pType.LISTFLOAT) {
                                        return {
                                            'key': p.key,
                                            'value': Array.isArray(p.value) ? p.value : p.value.split(',').map((t: string) => Number(t))
                                        }
                                    }
                                    if (p.type === pType.LISTTEXT) {
                                        return {
                                            'key': p.key,
                                            'value': Array.isArray(p.value) ? p.value : p.value.split(',').map((t: string) => t.trim())
                                        }
                                    }

                                    return { 'key': p.key, 'value': p.value }
                                }
                                )
                            }
                        }
                        )
                    }
                })

                patientSchedule.therapies = therapiesUpdated;
            }

        }

        showLoader!()

        Patients.updatePatientSchedule(Number(id!), selectedProtocol?.id!, patientSchedule).then(
            (res) => {
                reset();
                hideLoader!()
            },
            (err) => {
                const message = err.response?.data?.message || err.message;
                const status = err.response?.status;
                hideLoader!();
                showToast!('patientSchedule-error', message, `Patient Schedule Error ${status ? `(${status})` : ''}`, 'danger');
            }
        )


    }

    const deleteProtocol = () => {
        showLoader!();
        Patients.deletePatientProtocol(Number(id!), protocolToDelete?.id!)
            .then(
                () => {
                    hideLoader!();
                    showToast!('protocol-success', 'Protocol istance deleted successfully', 'Delete Success', 'success');
                    handleDeleteModalClose();
                    reset();
                },
                (err) => {
                    const message = err.response?.data?.message || err.message;
                    const status = err.response?.status;
                    hideLoader!();
                    showToast!('protocol-error', message, `Protocols istances Error ${status ? `(${status})` : ''}`, 'danger');
                }
            )
    }

    const handleSessionFieldChange = (field: any) => (evt: React.ChangeEvent<HTMLInputElement>) => {
        const value = evt.target.value;
        setNewEvent({
            ...newEvent,
            resource: { ...newEvent.resource, [field]: value },
        })
    }

    const handleCustomTaskParameterChange = (field: any, index: number) => (evt: React.ChangeEvent<any>) => {
        const value = evt.target.value;
        let updatedTask = taskDetail;

        switch (taskDetail?.parameters[index].type) {
            case pType.INTEGER:
            case pType.FLOAT:
                updatedTask!.parameters[index].value = Number(value);
                break;
            case pType.BOOLEAN:
            case pType.TEXT:
                updatedTask!.parameters[index].value = value;
                break;
            case pType.SEEDFORRANDOM:
                updatedTask!.parameters[index].value[field] = value;
                break;
            case pType.GENERATEDQUESTIONS:
                break;
            case pType.ENUM:
                updatedTask!.parameters[index].value = Number(value);
                break;
            case pType.LISTINTEGER:

                updatedTask!.parameters[index].value = value
                /*                 updatedTask!.parameters[index].content = updatedTask!.parameters[index].content.split(',').map((t: string) => {
                                    let val: any = t.trim()
                                    val = Number(val)
                                    return val;
                                }) */

                break;
            case pType.LISTFLOAT:
                updatedTask!.parameters[index].value = value
                break;
            case pType.LISTTEXT:
                updatedTask!.parameters[index].value = value
                /*                 updatedTask!.parameters[index].content = updatedTask!.parameters[index].content.split(',').map((t: string) => t.trim()) */

                break;
            default:
        }

        setTaskDetail({ ...updatedTask! })
    }

    const handleGeneratedQuestionTaskParameterChange = (field: any, index: number, genQuestionIndex: number) => (evt: React.ChangeEvent<any>) => {
        const value = evt.target.value;
        let updatedTask = taskDetail;

        updatedTask!.parameters[index].value[genQuestionIndex][field] = value;

        setTaskDetail({ ...updatedTask! })
    }

    const saveCustomParameter = () => {

        let updatedCustomParams = customParams.filter((t) => t.id !== taskDetail?.id || t.sessionId !== taskDetail?.sessionId);
        updatedCustomParams.push(taskDetail!)

        let status = validateCustomParams(updatedCustomParams.find((tsk) => tsk.id === taskDetail?.id)?.parameters)

        if (!status.valid) {
            showToast!('customParam-error', status.errors, `Param customization error`, 'danger');
            return
        }

        setCustomParams([...updatedCustomParams])
        handleCustomizeTaskModalClose()

    }


    function validateCustomParams(updatedParams: TaskParameter[] | undefined) {
        let status: { valid: boolean, errors: string[] } = { valid: true, errors: [] }

        if (!updatedParams) {
            return status;
        }

        let validator = {
            [pType.INTEGER]: (param: TaskParameter) => {
                if (String(param.value).includes(',') || String(param.value).includes('.')) {

                    status.errors.push(`${param.key} value is not an integer\n`)
                }
                if (param.min) {
                    !(Number(param.value) >= Number(param.min)) && status.errors.push(`${param.key} value does not respect min limit: ${param.min}\n`)
                }
                if (param.max) {
                    !(Number(param.value) <= Number(param.max)) && status.errors.push(`${param.key} value does not respect max limit: ${param.max}\n`)
                }
            },
            [pType.FLOAT]: (param: TaskParameter) => {
                if (param.min) {
                    !(Number(param.value) >= Number(param.min)) && status.errors.push(`${param.key} value does not respect min limit: ${param.min}\n`)
                }
                if (param.max) {
                    !(Number(param.value) <= Number(param.max)) && status.errors.push(`${param.key} value does not respect max limit: ${param.max}\n`)
                }
            },
            [pType.TEXT]: (param: TaskParameter) => { },
            [pType.BOOLEAN]: (param: TaskParameter) => { },
            [pType.ENUM]: (param: TaskParameter) => { },
            [pType.GENERATEDQUESTIONS]: (param: TaskParameter) => { },
            [pType.SEEDFORRANDOM]: (param: TaskParameter) => { },
            [pType.LISTINTEGER]: (param: TaskParameter) => { },
            [pType.LISTFLOAT]: (param: TaskParameter) => { },
            [pType.LISTTEXT]: (param: TaskParameter) => { },
        }

        updatedParams.forEach(p => validator[p.type](p))

        if (status.errors.length) status.valid = false;

        return status
    }

    const renderScheduler = () => {
        const filteredEvents = myEvents!
            .filter(evt => filterDevice === 0 || evt.resource.deviceId === filterDevice);

        return (
            <>
                <Row className="gx-2 mb-3">
                    <Calendar
                        dayLayoutAlgorithm={'no-overlap'}
                        localizer={localizer}
                        events={filteredEvents}
                        startAccessor="start"
                        culture='it'
                        endAccessor="end"
                        eventPropGetter={eventPropGetter}
                        dayPropGetter={dayPropGetter}
                        onRangeChange={handleRangeChange}
                        onSelectEvent={handleSelectEvent}
                        onSelectSlot={handleSelectSlot}
                        onView={onView}
                        view={view}
                        views={['month', 'week', 'day']}
                        onNavigate={onNavigate}
                        selectable={newEvent.resource?.sessionId !== undefined}
                        date={date}
                        className='calendar'
                    />
                </Row>
            </>
        )
    }

    function customParamForm(index: number) {

        switch (taskDetail?.parameters[index].type) {
            case pType.INTEGER:
                return (<td colSpan={4}>
                    <Form.Control type="tel" pattern="-?[0-9]+" placeholder={t('taskParam.defVal')} size="sm" value={taskDetail?.parameters[index].value} onChange={handleCustomTaskParameterChange(taskDetail?.parameters[index].key, index)} />
                </td>
                )
            case pType.FLOAT:
                return (<td colSpan={4}>
                    <Form.Control type="tel" pattern="-?[0-9]+[.]?[0-9]+" placeholder={t('taskParam.defVal')} size="sm" value={taskDetail?.parameters[index].value} onChange={handleCustomTaskParameterChange(taskDetail?.parameters[index].key, index)} />
                </td>
                )
            case pType.BOOLEAN:
                return (<>
                    <td colSpan={4}>
                        <Form.Select size="sm" value={taskDetail?.parameters[index].value} onChange={handleCustomTaskParameterChange(taskDetail?.parameters[index].key, index)}>
                            <option value="true" >True</option>
                            <option value="false" >False</option>
                        </Form.Select>
                    </td>
                </>)
            case pType.TEXT:
                return <td colSpan={4}>
                    <Form.Control type="text" placeholder={t('taskParam.defVal')} size="sm" value={taskDetail?.parameters[index].value} onChange={handleCustomTaskParameterChange(taskDetail?.parameters[index].key, index)} />
                </td> //handleCustomTaskParameterChange
            case pType.SEEDFORRANDOM:
                return (<>
                    <td>
                        <Form.Control type="tel" pattern="-?[0-9]+" placeholder={t('taskParam.s0')} size="sm" value={taskDetail?.parameters[index].value.s0} onChange={handleCustomTaskParameterChange('s0', index)} />
                    </td>
                    <td>
                        <Form.Control type="tel" pattern="-?[0-9]+" placeholder={t('taskParam.s1')} size="sm" value={taskDetail?.parameters[index].value.s1} onChange={handleCustomTaskParameterChange('s1', index)} />
                    </td>
                    <td>
                        <Form.Control type="tel" pattern="-?[0-9]+" placeholder={t('taskParam.s2')} size="sm" value={taskDetail?.parameters[index].value.s2} onChange={handleCustomTaskParameterChange('s2', index)} />
                    </td>
                    <td>
                        <Form.Control type="tel" pattern="-?[0-9]+" placeholder={t('taskParam.s3')} size="sm" value={taskDetail?.parameters[index].value.s3} onChange={handleCustomTaskParameterChange('s3', index)} />
                    </td>
                </>)
            case pType.GENERATEDQUESTIONS:
                return (
                    <td colSpan={4}>
                        {taskDetail?.parameters[index].content.map((x: any, gQi: number) => {
                            return (
                                <div className='d-flex justify-content-between mb-1 align-items-center' key={`q-${gQi}`}>
                                    <Col md={3}>
                                        <Form.Label> Question</Form.Label>
                                        <Form.Control type="text" placeholder={t('taskParam.defVal')} size="sm" value={taskDetail?.parameters[index].value[gQi].question} onChange={handleGeneratedQuestionTaskParameterChange('question', index, gQi)} />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Label> Answers</Form.Label>
                                        <Form.Control type="text" placeholder={t('taskParam.defVal')} size="sm" value={taskDetail?.parameters[index].value[gQi].answers} onChange={handleGeneratedQuestionTaskParameterChange('answers', index, gQi)} />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Label> Correct </Form.Label>
                                        <Form.Control type="text" placeholder={t('taskParam.defVal')} size="sm" value={taskDetail?.parameters[index].value[gQi].correct} onChange={handleGeneratedQuestionTaskParameterChange('correct', index, gQi)} />
                                    </Col>
                                </div>
                            )
                        })
                        }
                    </td>
                )
            case pType.ENUM:
                return (<>
                    <td colSpan={4}>
                        <Row>
                            <Col md={8}>
                                <Form.Control type="number" min={taskDetail?.parameters[index].min} max={taskDetail?.parameters[index].max} placeholder={t('taskParam.enumKey')} size="sm" value={taskDetail?.parameters[index].value} onChange={handleCustomTaskParameterChange(taskDetail?.parameters[index].key, index)} />
                            </Col>
                            <Col md={4} className='border-left'>
                                <span className='float-end'>{taskDetail?.parameters[index].description}</span>
                            </Col>
                        </Row>
                    </td>
                </>)
            case pType.LISTINTEGER:
                return (<>
                    <td colSpan={4}>
                        <Row>
                            <Col >
                                <Form.Control placeholder={t('taskParam.intList')} size="sm" value={taskDetail?.parameters[index].value} onChange={handleCustomTaskParameterChange(taskDetail?.parameters[index].key, index)} />
                            </Col>

                        </Row>
                    </td>
                </>)
            case pType.LISTFLOAT:
                return (<>
                    <td colSpan={4}>
                        <Row>
                            <Col >
                                <Form.Control placeholder={t('taskParam.floatList')} size="sm" value={taskDetail?.parameters[index].value} onChange={handleCustomTaskParameterChange(taskDetail?.parameters[index].key, index)} />
                            </Col>

                        </Row>
                    </td>
                </>)
            case pType.LISTTEXT:
                return (<>
                    <td colSpan={4}>
                        <Row>
                            <Col >
                                <Form.Control placeholder={t('taskParam.textList')} size="sm" value={taskDetail?.parameters[index].value} onChange={handleCustomTaskParameterChange(taskDetail?.parameters[index].key, index)} />
                            </Col>

                        </Row>
                    </td>
                </>)
            default:
                return (<td></td>)
        }

    }

    const renderAsyncContent = () => {
        return myEvents
            ? renderScheduler()
            : (
                <div className="d-flex justify-content-center py-5">
                    <AppLoader size={150} />
                </div>
            )
    }

    return (
        <Container fluid>
            <Breadcrumb>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/patients' }}>{t('pages.patients')}</Breadcrumb.Item>
                <Breadcrumb.Item active>{`Schedulazione paziente ${patientDetail?.firstname} ${patientDetail?.lastname} `}</Breadcrumb.Item>
            </Breadcrumb>
            <Card>
                <Row className="d-flex align-items-center justify-content-between border-bottom py-1 px-3">
                    <Col md={4}>
                        <Card.Title className="mb-0 py-3">Calendario paziente{/*t('sessionEdit.title')*/}</Card.Title>
                    </Col>
                    <Col md={4} className='d-flex justify-content-between align-items-center'>
                        <div className='d-flex align-items-center w-100'>
                            <h6 className='mb-0 me-2'>Vai a</h6>
                            <div className="w-50 ">
                                <input className="datepicker" type='month' value={format(date, 'yyyy-MM')} onChange={handleGoTo}></input>
                            </div>
                        </div>
                        <div className='d-flex align-items-center w-100'>
                            <h6 className='mb-0 me-2'>Filtro Device</h6>
                            <div className="w-50 ">
                                <Form.Select size="sm" onChange={handleDeviceFilterChange} >
                                    <option key="default" value={0}>Tutti i device</option>
                                    {devicesList && devicesList.map(dev => (
                                        <option key={dev.id} value={dev.id}>{dev.label}</option>
                                    ))}
                                </Form.Select>
                            </div>
                        </div>
                    </Col>

                    <Col md={4} className='d-flex justify-content-end'>

                        {newEvent.resource?.sessionId !== undefined &&
                            <Alert className="py-2 mb-0" >
                                <FontAwesomeIcon icon={solid('info-circle')} />
                                <span className="ms-2">Fai click su un giorno del calendario per schedulare la sessione.{/* {t('batteriesList.noBatteries')} */}</span>
                            </Alert>
                        }

                        {!selectedProtocol && <>
                            <Button className="mb-0" variant="success" size="sm" onClick={openSelectProtocolModal}>
                                <FontAwesomeIcon icon={solid('plus')} />
                                <span className="ms-2"> {t('schedulerPage.scheduleProtocol')}</span>
                            </Button>
                        </>
                        }

                        {selectedProtocol && <>
                            <Button className="mb-0 me-3" variant="secondary" size="sm" onClick={reset}>
                                <FontAwesomeIcon icon={solid('times')} />
                                <span className="ms-2">{t('common.cancel')}</span>
                            </Button>
                            <Button className="mb-0" variant="success" size="sm" onClick={selectedProtocol.protocolId ? updateSchedule : saveSchedule}>
                                <FontAwesomeIcon icon={solid('save')} />
                                <span className="ms-2">{t('schedulerPage.saveSchedule')}</span>
                            </Button>
                        </>
                        }

                    </Col>

                </Row>
                <Row>
                    <Col md={4} className=' border border-top-0 border-left-0 border-bottom-0 protocols-tab'>
                        <Card.Body >
                            {!selectedProtocol &&
                                <>
                                    <h5> Protocolli schedulati </h5>
                                    {!schedule?.protocols.length && <Alert className="mb-0 py-2">
                                        <FontAwesomeIcon icon={solid('info-circle')} />
                                        <span className="ms-2">Nessun protocollo schedulato.{/* {t('batteriesList.noBatteries')} */}</span>
                                    </Alert>}

                                    <Accordion
                                        className="protocols-accordions"
                                        activeKey={activeProtocol}
                                        onSelect={handleActiveProtocolChange}
                                    >

                                        {schedule?.protocols.map((prot, indexSes) => (
                                            <ListGroup key={indexSes}>

                                                <ListGroup.Item className={` d-flex align-items-center justify-content-between`}>
                                                    <span>{prot.name}</span>
                                                    <span></span>
                                                    <div>
                                                        {!(prot.therapies as any[]).every((t: any) => t.isCompleted === 1) && <>
                                                            <IconButton className="ms-2" >
                                                                <FontAwesomeIcon icon={solid('pen')} onClick={() => modifyProtocolIstance(prot.id!)} />
                                                            </IconButton>
                                                            <IconButton className="ms-2" onClick={() => openDeleteModal(prot.id!)} >
                                                                <FontAwesomeIcon className="text-danger" icon={solid('trash')} />
                                                            </IconButton>
                                                        </>
                                                        }
                                                        <ContextAwareToggle eventKey={String(indexSes)} />
                                                    </div>
                                                </ListGroup.Item>
                                                <Accordion.Collapse eventKey={String(indexSes)}>
                                                    <>
                                                        {prot.therapies.length === 0 && (
                                                            <Alert className="py-2 mb-0">
                                                                <FontAwesomeIcon icon={solid("info-circle")} />
                                                                <span className="ms-2">No session in this protocol.</span>
                                                            </Alert>
                                                        )}

                                                        {prot.therapies!.length > 0 && (
                                                            <ListGroup>
                                                                {prot.therapies.map((thera, j) => (
                                                                    <ListGroup.Item className="d-flex align-items-center" key={j}>
                                                                        <Col>
                                                                            {thera.isCompleted ?
                                                                                <span className='highlight' onClick={() => navigate(`/therapy/${thera!.therapyId}`)}> {thera.name || thera.sessionName}</span>
                                                                                :
                                                                                <span  >{thera.name || thera.sessionName}</span>
                                                                            }

                                                                        </Col>
                                                                        <Col className="text-center">
                                                                            {thera.scheduledDate ?
                                                                                <>
                                                                                    <FontAwesomeIcon icon={solid('calendar-days')} />
                                                                                    <span className='ms-2'>{thera.scheduledDate ? format(parseISO(thera.scheduledDate), "yyyy-MM-dd HH:mm") : ''}</span>
                                                                                </>
                                                                                :
                                                                                <FontAwesomeIcon icon={solid('clock')} color='orange' />
                                                                            }

                                                                        </Col>
                                                                        <Col className='d-flex justify-content-end'>
                                                                            {thera.isCompleted ?
                                                                                <FontAwesomeIcon icon={solid('circle-check')} color="green" />

                                                                                :
                                                                                <FontAwesomeIcon icon={solid('hourglass-end')} color="orange" />
                                                                            }

                                                                            {!thera.isCompleted && thera.scheduledDate &&
                                                                                <IconButton className="ms-3 p-0" onClick={() => { openTherapyRemoveModal(thera) }} >
                                                                                    <FontAwesomeIcon className="text-danger" icon={regular('calendar-times')} />
                                                                                </IconButton>
                                                                            }
                                                                        </Col>

                                                                    </ListGroup.Item>

                                                                ))}
                                                            </ListGroup>
                                                        )}
                                                    </>
                                                </Accordion.Collapse>


                                            </ListGroup>
                                        ))}


                                    </Accordion>

                                </>
                            }

                            {selectedProtocol &&
                                <>
                                    <h5> Sessioni protocollo {selectedProtocol.name}  </h5>

                                    {
                                        <Accordion
                                            className="sessions-accordions"
                                            activeKey={activeSession}
                                            onSelect={handleActiveSessionChange}
                                        >

                                            {selectedProtocol.therapies!.map((ses, indexSes) => (
                                                <ListGroup key={indexSes}>
                                                    <ListGroup.Item className={`${newEvent.resource?.sessionId! === ses.sessionId ? 'bg-light ' : ''} d-flex align-items-center justify-content-between`}>
                                                        <span>{ses.label || ses.name || ses.sessionName}</span>
                                                        {ses.scheduled &&
                                                            <span>{format(ses.scheduled!, "dd/MM/yyyy HH:mm")}</span>
                                                        }
                                                        {ses.scheduledDate &&
                                                            <span>{format(parseISO(ses.scheduledDate!), "dd/MM/yyyy HH:mm")}</span>
                                                        }
                                                        <div>

                                                            {!ses.scheduledDate && !ses.scheduled && !ses.id &&
                                                                <IconButton className="ms-2" onClick={() => selectSessionToAdd(ses.sessionId)}>
                                                                    <FontAwesomeIcon icon={solid('plus')} />
                                                                </IconButton>
                                                            }


                                                            {ses.scheduled && <>
                                                                <IconButton className="ms-2" onClick={() => reScheduleSession(ses.sessionId)} >
                                                                    <FontAwesomeIcon icon={solid('pen')} />
                                                                </IconButton>
                                                                <IconButton className="ms-2" onClick={() => removeScheduledSession(ses.sessionId)}>
                                                                    <FontAwesomeIcon className="text-danger" icon={solid('trash')} />
                                                                </IconButton>
                                                            </>
                                                            }

                                                            {(ses.scheduledDate || ses.id) && <>
                                                                <IconButton className="ms-2" onClick={() => reScheduleExistingSession(ses.therapyId)} >
                                                                    <FontAwesomeIcon icon={solid('pen')} />
                                                                </IconButton>
                                                            </>
                                                            }

                                                            <ContextAwareToggle eventKey={String(indexSes)} />
                                                        </div>
                                                    </ListGroup.Item>
                                                    <Accordion.Collapse eventKey={String(indexSes)}><>
                                                        {ses.tasks.length === 0 && (
                                                            <Alert className="py-2 mb-0">
                                                                <FontAwesomeIcon icon={solid("info-circle")} />
                                                                <span className="ms-2">No tasks in this session.</span>
                                                            </Alert>
                                                        )}

                                                        {ses.tasks!.length > 0 && (
                                                            <ListGroup>
                                                                {ses.tasks.map((task, j) => (
                                                                    <ListGroup.Item className="d-flex align-items-center" key={j}>
                                                                        <Col>
                                                                            <h6 className="mb-0">{task.name}</h6>
                                                                        </Col>

                                                                        <Col md={3} className="text-end">
                                                                            {task.taskId ?
                                                                                <IconButton className="ms-2" onClick={() => customizeTaskIstance(task.id!, ses.sessionId)} >
                                                                                    <FontAwesomeIcon icon={solid('pen')} />
                                                                                </IconButton>
                                                                                :
                                                                                <IconButton className="ms-2" onClick={() => customizeTask(task.id!, ses.sessionId)} >
                                                                                    <FontAwesomeIcon icon={solid('pen')} />
                                                                                </IconButton>
                                                                            }
                                                                        </Col>
                                                                    </ListGroup.Item>

                                                                ))}
                                                            </ListGroup>
                                                        )}
                                                    </>
                                                    </Accordion.Collapse>
                                                </ListGroup>
                                            ))}
                                        </Accordion>

                                    }

                                </>
                            }

                        </Card.Body>
                    </Col>
                    <Col md={8}>
                        <Card.Body>

                            {renderAsyncContent()}

                            {/* 
                            <Button className="float-end mb-2 me-3" variant="warning" size="sm" onClick={logs}>
                                <span className="">Logs</span>
                            </Button> 
                            */}
                        </Card.Body>

                    </Col>

                </Row>
            </Card>

            <Modal show={showSelecProtocolModal} onHide={handleSelectProtocolModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Schedulazione protocollo{/* {editing !== undefined ? t('common.edit') : t('common.create')} {t('common.pathology')} */}</Modal.Title>
                </Modal.Header>

                <Form >
                    <Modal.Body>
                        <Form.Group controlId="selected-protocol" className="mb-3">
                            <Form.Label>{t('common.name')}</Form.Label>
                            <Form.Select size="sm" defaultValue={selectedProtocol ? selectedProtocol!.name : 'Seleziona protocollo da schedulare'} onChange={handleSelectedProtocolChange}>
                                <option key="default" value="Seleziona protocollo da schedulare" hidden disabled>Seleziona protocollo da schedulare{/* t('groupMembers.selectGroup') */}</option>
                                {protocols && protocols!.map(prot => (
                                    <option key={prot.id} value={prot.id}>{prot.name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="light" className="border" size="sm" onClick={handleSelectProtocolModalClose}>{t('common.cancel')}</Button>
                        <Button variant="success" size="sm" onClick={() => { setSelectProtocolModal(false) }}>{t('common.confirm')} </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            <Modal show={showAddSessionModal} onHide={handleAddSessionModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Inserimento sessione{/* {editing !== undefined ? t('common.edit') : t('common.create')} {t('common.pathology')} */}</Modal.Title>
                </Modal.Header>

                <Form validated={validated} onSubmit={handleAddSession}>
                    <Modal.Body>

                        <Form.Group controlId="selected-device" className="mb-3">
                            <Form.Label>{t('common.device')}</Form.Label>
                            <Form.Select required as="select" size="sm" value={newEvent.resource?.deviceId! ?? ''} onChange={handleTherapyDeviceChange} >

                                <option key="default" value="" hidden disabled>Seleziona device da utilizzare{/* t('groupMembers.selectGroup') */}</option>
                                {devicesList && devicesList.filter(dev => dev.status === 'ok' && !dev.deleted).map(dev => (
                                    <option key={dev.id} value={dev.id}>{dev.label}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group controlId="session-time">
                            <Form.Label>{t('common.time')}</Form.Label>
                            <Form.Control placeholder={t('sessionEdit.pathologyDescription')} size="sm" type='time' value={newEvent?.resource?.scheduledDate ?? ''} onChange={handleSessionFieldChange('scheduledDate')} required />
                        </Form.Group>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="light" className="border" size="sm" onClick={handleAddSessionModalClose}>{t('common.cancel')}</Button>
                        <Button variant="success" size="sm" type='submit'>{t('common.confirm')} </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            <Modal show={showSessionDetailModal} onHide={handleSessionDetailModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title> {(sessionDetail?.title as String)?.split('-')[0]}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table className="">
                        <thead className='table-light'>
                            <tr>
                                <th scope="col" colSpan={2}>{(sessionDetail?.title as String)?.split('-')[1]}</th>
                            </tr>
                        </thead>
                        <tbody className="">
                            <tr>
                                <th scope="row">Orario</th>

                                <td>{sessionDetail?.resource.time}</td>
                            </tr>
                            <tr>
                                <th scope="row">Durata</th>
                                <td>{sessionDetail?.resource.duration} min</td>
                            </tr>
                            <tr>
                                <th scope="row">Device</th>
                                <td>{devicesList?.find(dev => dev.id === sessionDetail?.resource.deviceId)?.label}</td>
                            </tr>
                            <tr>
                                <th scope="row">Paziente</th>
                                <td>{sessionDetail?.resource.patientName}</td>
                            </tr>
                            <tr>
                                <th scope="row">Completato</th>
                                <td>{sessionDetail?.resource.isCompleted ? 'Si' : 'No'}</td>
                            </tr>
                        </tbody>
                    </Table>
                    {sessionDetail?.resource?.isCompleted ?
                        <Button className="float-end" onClick={() => navigate(`/therapy/${sessionDetail!.resource.therapyId}`)}> Show Results</Button>
                        : <></>
                    }
                </Modal.Body>
            </Modal>

            <Modal show={showCustomizeTaskModal} onHide={handleCustomizeTaskModalClose} dialogClassName="modal-xxl" size='xl'>
                <Modal.Header closeButton>
                    <Modal.Title> {taskDetail?.name} </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table bordered>
                        <thead>
                            <tr>
                                <th scope='col' colSpan={1} className='w-25'> Parametro </th>

                                <th scope='col' colSpan={4}> Valore</th>
                                <th scope='col' colSpan={1}> Unità</th>
                            </tr>
                        </thead>
                        <tbody>
                            {taskDetail?.parameters.map((param, i) => {
                                if (param.key !== 'task_name') {
                                    return (<tr key={i}>
                                        <td colSpan={1}>{param.key}</td>

                                        {customParamForm(i)}
                                        <td colSpan={1}>{param.unit}</td>
                                    </tr>
                                    )
                                }
                            })}
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" className="border" size="sm" onClick={handleCustomizeTaskModalClose}>{t('common.cancel')}</Button>
                    <Button variant="success" size="sm" onClick={saveCustomParameter}>{t('common.confirm')}</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDeleteModal} onHide={handleDeleteModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('common.deleteTitle', { item: t('common.protocol') })}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t('schedulerPage.deleteMessage')} <b>{protocolToDelete?.name}</b>?

                    <h5 className="my-4 text-center text-danger">{t('common.deleteWarning')}</h5>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="light" className="border" size="sm" onClick={handleDeleteModalClose}>{t('common.cancel')}</Button>
                    <Button variant="danger" size="sm" onClick={deleteProtocol}>{t('common.delete')}</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showRemoveScheduledModal} onHide={handleRemoveScheduleModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('common.deleteTitle', { item: t('common.session') })}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t('schedulerPage.removeTherapy')} <b>{scheduleToRemove?.sessionName!}</b>?

                    <h5 className="my-4 text-center text-danger">{t('common.deleteWarning')}</h5>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="light" className="border" size="sm" onClick={handleRemoveScheduleModal}>{t('common.cancel')}</Button>
                    <Button variant="danger" size="sm" onClick={removeScheduledTherapy}>{t('common.delete')}</Button>
                </Modal.Footer>
            </Modal>

        </Container >
    )
}